var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42373 3.82011C0.637425 3.82011 0 3.18269 0 2.39639C0 1.61008 0.637425 0.972656 1.42373 0.972656C2.21003 0.972656 2.84746 1.61008 2.84746 2.39639C2.84746 3.18269 2.21003 3.82011 1.42373 3.82011ZM4.74577 1.65265H14V3.23457H4.74577V1.65265ZM0 7.05637C0 7.84267 0.637425 8.4801 1.42373 8.4801C2.21003 8.4801 2.84746 7.84267 2.84746 7.05637C2.84746 6.27007 2.21003 5.63264 1.42373 5.63264C0.637425 5.63264 0 6.27007 0 7.05637ZM1.42373 13.0801C0.637425 13.0801 0 12.4427 0 11.6564C0 10.8701 0.637425 10.2326 1.42373 10.2326C2.21003 10.2326 2.84746 10.8701 2.84746 11.6564C2.84746 12.4427 2.21003 13.0801 1.42373 13.0801ZM14 6.24599H4.74577V7.82791H14V6.24599ZM4.74577 10.846H14V12.4279H4.74577V10.846Z",
    fill: "#666687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFooter);
export default __webpack_public_path__ + "static/media/ic-footer.23256128382272c689246a12ed6d3f2e.svg";
export { ForwardRef as ReactComponent };